enum CardConnectionType {
  Connect = 'connect',
  Disconnect = 'disconnect',
}

export {CardConnectionType};
